<template>
    <div>
        <limitless-page-header
            title="Sales CRM"
            :sub-title="$route.meta.name"
        >
            <template v-if="$route.name==='crm.companies'" #header-elements>
                <limitless-page-header-button :route="{ name: 'crm.company', params: {id: 0} }" icon="icon-plus3">Nytt företag</limitless-page-header-button>
            </template>
        </limitless-page-header>

        <crm-menu></crm-menu>

        <div class="content">
            <transition name="fade" mode="out-in">
                <router-view :users="users" :companies="companies" :strings="strings" />
            </transition>
        </div>
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import LimitlessPageHeaderButton from '@components/Layout/partials/LimitlessPageHeaderButton';
import apiClient from '@services/ApiClient';
import CrmMenu from '@app/pages/sales_crm/partials/CrmMenu.vue';

export default {
    name: 'SalesCrm',
    components: {
        CrmMenu,
        LimitlessPageHeader,
        LimitlessPageHeaderButton,
    },
    data: () => ({
        users: [],
        companies: {},
        strings: {},
    }),
    created() {
        const vm = this;
        apiClient.get('/vue/sales/crm/select_users')
            .then((response) => {
                vm.users = response.data;
            });
        apiClient.get('/vue/sales/crm/select_companies')
            .then((response) => {
                vm.companies = response.data;
            });
        apiClient.get('/vue/sales/crm/select_strings')
            .then((response) => {
                vm.strings = response.data;
            });
    },
};
</script>
